const ArrowRight = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            width="14"
            height="8"
            viewBox="0 0 14 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1 3.68937C1 3.68937 8.61303 3.22704 12.3425 3.68937"
                stroke="#696158"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.40405 0.499268C10.7247 1.4028 11.932 2.4617 12.9999 3.65333C12.9999 3.65333 10.3852 5.88791 9.53759 7.50093"
                stroke="#696158"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default ArrowRight
